type AdditionalAttributes = Record<string, unknown> | undefined

export function mergeAdditionalAttributes(
  existing: AdditionalAttributes,
  edits: AdditionalAttributes,
): Record<string, unknown> | undefined {
  if (edits === undefined) return undefined
  return { ...(existing ?? {}), ...edits }
}
